import { render, staticRenderFns } from "./CampusTravelFields.vue?vue&type=template&id=67da861c&scoped=true"
import script from "./CampusTravelFields.vue?vue&type=script&lang=js"
export * from "./CampusTravelFields.vue?vue&type=script&lang=js"
import style0 from "./CampusTravelFields.vue?vue&type=style&index=0&id=67da861c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67da861c",
  null
  
)

export default component.exports